import { Injectable } from '@angular/core';

interface CrmChallengeContext {
  challengeToken: string;
  email: string;
  otpExpiresAtEpochMs: number;
  resendAvailableAtEpochMs: number;
}

const CHALLENGE_STORAGE_KEY = 'crm.challenge-context';
const PERSIST_LOGIN_KEY = 'crm.persist-login';

@Injectable({ providedIn: 'root' })
export class CrmAuthFlowService {
  private challengeContext: CrmChallengeContext | null = null;
  private persistLogin = false;

  setChallengeContext(context: {
    challengeToken: string;
    email: string;
    otpExpiresInSeconds: number;
    resendAvailableInSeconds: number;
  }): void {
    const now = Date.now();
    const nextContext: CrmChallengeContext = {
      challengeToken: context.challengeToken,
      email: context.email,
      otpExpiresAtEpochMs: now + Math.max(context.otpExpiresInSeconds, 0) * 1000,
      resendAvailableAtEpochMs: now + Math.max(context.resendAvailableInSeconds, 0) * 1000,
    };

    this.challengeContext = nextContext;

    if (typeof window !== 'undefined') {
      sessionStorage.setItem(CHALLENGE_STORAGE_KEY, JSON.stringify(nextContext));
    }
  }

  getChallengeContext(): CrmChallengeContext | null {
    if (this.challengeContext) {
      return this.challengeContext;
    }

    if (typeof window === 'undefined') {
      return null;
    }

    const raw = sessionStorage.getItem(CHALLENGE_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    try {
      this.challengeContext = JSON.parse(raw) as CrmChallengeContext;
      return this.challengeContext;
    } catch {
      sessionStorage.removeItem(CHALLENGE_STORAGE_KEY);
      return null;
    }
  }

  clearChallengeContext(): void {
    this.challengeContext = null;

    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(CHALLENGE_STORAGE_KEY);
    }
  }

  setPersistLogin(value: boolean): void {
    this.persistLogin = value;

    if (typeof window !== 'undefined') {
      sessionStorage.setItem(PERSIST_LOGIN_KEY, value ? '1' : '0');
    }
  }

  shouldPersistLogin(): boolean {
    if (typeof window !== 'undefined') {
      const raw = sessionStorage.getItem(PERSIST_LOGIN_KEY);
      if (raw === '1' || raw === '0') {
        this.persistLogin = raw === '1';
      }
    }

    return this.persistLogin;
  }

  clearPersistLogin(): void {
    this.persistLogin = false;

    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(PERSIST_LOGIN_KEY);
    }
  }
}